import * as React from 'react';
import {default as CommonStreamItem} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import Payment from "../../../../model/payment/Payment";
import CurrencyHelper from "../../../../helper/CurrencyHelper";
import {IconColor} from "../../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

interface ComponentProps {
	/**
	 * Bill activity to display.
	 */
	activity: Payment;
	/**
	 * Stream item icon to be displayed.
	 */
	icon?: string;
	/**
	 * Color of displayed stream item icon background.
	 */
	iconColor?: IconColor;
	/**
	 * Color of stream item icon.
	 */
	iconVariant?: "white" | "orange" | "green";
	/**
	 * If true, creator name is not displayed in creation info.
	 */
	hideCreator?: boolean;
	/**
	 * Render complex body message (by default this.renderBodyMessage())
	 */
	renderBodyMessage?: () => JSX.Element
}

type Props = ComponentProps;

export class BillActivityPaymentItem extends React.Component<Props, {}> {
	render() {
		return (
			<CommonStreamItem event={this.props.activity}
							  hideCreator={!this.props.activity.creator || this.props.hideCreator}
							  renderBodyMessage={this.props.renderBodyMessage ? this.props.renderBodyMessage :
								  this.renderBodyMessage}
							  icon={this.props.icon}
							  iconColor={this.props.iconColor}
							  iconVariant={this.props.iconVariant}/>
		);
	}

	/**
	 * Render activity item body message with bold amount.
	 * @returns {any}
	 */
	renderBodyMessage = () =>
		<div>
			<b>{CurrencyHelper.toCurrency(this.props.activity.amount)}</b> {this.props.activity.getActivityMessage()}
		</div>
}
